/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyAuditSummary from './pharmacy-audit-summary';
import PharmacyAuditSummaryDetail from './pharmacy-audit-summary-detail';
import PharmacyAuditSummaryUpdate from './pharmacy-audit-summary-update';
import PharmacyAuditSummaryDeleteDialog from './pharmacy-audit-summary-delete-dialog';

const PharmacyAuditSummaryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyAuditSummary />} />
    <Route path="new" element={<PharmacyAuditSummaryUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyAuditSummaryDetail />} />
      <Route path="edit" element={<PharmacyAuditSummaryUpdate />} />
      <Route path="delete" element={<PharmacyAuditSummaryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyAuditSummaryRoutes;
